import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// molecule — DWR step header: numero step (Cinzel smallcaps) + titolo h2 display + sub italic.
// Pattern .step-header / .step-header__no / .step-header__sub mockup
// (dev-workspace/mockups/.../project/styles.css righe 281-304).
// Usata sia dalle 10 sezioni del builder (PR 3) sia dai 12 step level-up (PR 8).
// Il mockup usa <h1> perché single-step; qui usiamo <h2> perché review-continuo
// (10 sezioni nella stessa pagina; il <h1> è implicito nel topbar/brand).
//
// **PR 8**: `stepNumber` opzionale. Nei step level-up il numero step è già
// visibile sia nello `<StepNav>` ("Step X / N") sia nello `<StepRail>` —
// duplicarlo nel header sarebbe rumore visivo. Builder lo passa, level-up no.

interface SectionHeaderProps {
  stepNumber?: string;
  title: ReactNode;
  sub?: ReactNode;
  className?: string;
}

export function SectionHeader({ stepNumber, title, sub, className }: SectionHeaderProps) {
  return (
    <header className={cn('mb-6', className)}>
      {stepNumber ? (
        <span className="font-display text-ink-faint text-[0.8rem] tracking-[0.18em] uppercase">
          {stepNumber}
        </span>
      ) : null}
      <h2 className="font-display mx-0 mt-[0.1em] mb-[0.2em] text-[clamp(2rem,4vw,2.8rem)] leading-[1.05] font-bold tracking-[0.01em]">
        {title}
      </h2>
      {sub ? <p className="text-ink-soft m-0 italic">{sub}</p> : null}
    </header>
  );
}
